import { InfoMessage } from 'components';
import Label from 'components/fieldLabel';

  
  export const registerDocs = () =>
  [
    {
      label: "Πιστοποιητικό ισχύουσας εκπροσώπησης ΓΕΜΗ",
      fileCode: 'certGemi',
      id: 'certGemi',
      multiple: false,
      fileLimit: 10,
      required: true,
    },
    {
      label: "Στοιχεία μητρώου επιχείρησης ΑΑΔΕ",
      fileCode: 'registAade',
      id: 'registAade',
      multiple: false,
      fileLimit: 10,
      required: true,
    },
    {
      label: "Υπεύθυνη δήλωση",
      fileCode: 'respStatement',
      id: 'respStatement',
      multiple: false,
      fileLimit: 10,
      required: true,
    },
  ].filter(item => item);